import $ from "jquery";
import { Klass, csl, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import defaultSlickOptions from "./importSlick";

vuwer.appendKlass("VuwSlider", {
	slickOptions: null,
	classNames: {
		self: "vuw-slider",
		item: "vuw-slide-item"
	},
	
	/**
	 * [コンストラクタ]
	 *
	 * @param {Object} [opt]
	 * @returns this | false
	 */
	_initialize(opt) {
		if( u_.isObject(opt) ) {
			// onReadyFirstが指定されている場合は退避
			if( u_.isFunction(opt.onReadyFirst) ) {
				this._onReadyFirst = opt.onReadyFirst;
				delete opt.onReadyFirst;
			}
			
			// onReadyLastが指定されている場合は退避
			if( u_.isFunction(opt.onReadyLast) ) {
				this._onReadyLast = opt.onReadyLast;
				delete opt.onReadyLast;
			}
			
		} else {
			opt = {};
		}
		
		u_.isObject(opt.slickOptions) || (opt.slickOptions = {});
		
		const _super_ = Klass("VuwSlider").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		return this;
	},
	
	onReadyFirst($self) {
		if($self) {
			$self.addClass(this.classNames.self);
			const elm = $self.get(0);
			elm.vuw = this;
			Klass("VuwSlider").observer.observe(elm);
		}
		
		const args = u_.getAsArray(arguments);
		if( u_.isFunction(this._onReadyFirst) ) {
			return this._onReadyFirst(...args);
		}
	},
	
	onReadyLast($self) {
		if($self) {
			const $slides = $self.children().addClass(this.classNames.item);
			const isSlides = ($slides.length > 1);
			const $ghostBox = $("<div/>").addClass(
				`${this.classNames.self}-ghost-box`
			).insertBefore($self);
			this.setProp({ $slides, isSlides, $ghostBox });
			
			this.updateSlides();
			
			vuwer.$window.on("resize", e => {
				clearTimeout(this._resizeTimer);
				this._resizeTimer = setTimeout(() => this.updateSlides(), 200);
			});
			
			$self.on("click", e => {
				$self.slick("slickPause");
			})
		}
		
		const args = u_.getAsArray(arguments);
		if( u_.isFunction(this._onReadyLast) ) {
			return this._onReadyLast(...args);
		}
	},
	
	
	getMQ() {
		let rtn = "sp";
		if(this.$ghostBox.css("position") === "relative") {
			rtn = "pc";
		}
		return rtn;
	},
	
	updateSlides() {
		const mq = this.getMQ();
		if(this.isSlides && mq !== this.mq) {
			!!this.mq && csl.log.orange("change mq.");
			this.$self.hasClass("slick-initialized") && this.$self.slick("unslick");
			
			this.$self.slick({ ...defaultSlickOptions, ...this.slickOptions });
			
			this.mq = mq;
		}
		
		return this;
	}
});


// [IntersectionObserver as InView]
const VuwSlider = Klass("VuwSlider");
VuwSlider.observer = new IntersectionObserver(entries => {
	entries.forEach(e => {
		const { vuw } = e.target;
		if(vuw.isSlides) {
			vuw.$self.slick(e.isIntersecting ? "slickPlay" : "slickPause");
		}
	});
});


export default VuwSlider;
